import { FiltersTagType } from '../get-data/transform/filters-tags-list';

export const UPDATE_FILTERS_TAGS_LIST = 'UPDATE_FILTERS_TAGS_LIST';

export const updateFiltersTagsList = (payload: FiltersTagType[]) => ({
    type: UPDATE_FILTERS_TAGS_LIST,
    payload,
});

export default (state: FiltersTagType[] = [], action: ReturnType<typeof updateFiltersTagsList>) =>
    action.type === UPDATE_FILTERS_TAGS_LIST ? action.payload : state;
